// extracted by mini-css-extract-plugin
module.exports = {"kpiValue":"kpiStyles_kpiValue__7X-qA","green":"kpiStyles_green__1VyTt","red":"kpiStyles_red__1cgBi","kpiLabel":"kpiStyles_kpiLabel__zgTyT","kpi":"kpiStyles_kpi__3Uba4"};